import salon1 from "../Images/Hairstyles/salon1.jpeg";
import salon2 from "../Images/Hairstyles/salon2.jpeg";
import salon3 from "../Images/Hairstyles/salon3.jpeg";
import salon4 from "../Images/Hairstyles/salon4.jpeg";

import boxBraid10 from "../Images/Hairstyles/malestyles/boxbraids10.jpeg";
import malecornrow1 from "../Images/Hairstyles/malestyles/cornrow1.jpeg";
import malecornrow2 from "../Images/Hairstyles/malestyles/cornrow2.jpeg";
import afro1 from "../Images/Hairstyles/afro1.jpeg";
import afro2 from "../Images/Hairstyles/afro2.jpeg";
import afro3 from "../Images/Hairstyles/afro3.jpeg";
import afro4 from "../Images/Hairstyles/afro4.jpeg";
import afro5 from "../Images/Hairstyles/afro5.jpeg";
import afro6 from "../Images/Hairstyles/afro6.jpeg";
import afro7 from "../Images/Hairstyles/afro7.jpeg";
import afro8 from "../Images/Hairstyles/afro8.jpeg";
import afro9 from "../Images/Hairstyles/afro9.jpeg";
import afro10 from "../Images/Hairstyles/afro10.jpeg";
import boxBraid1 from "../Images/Hairstyles/box-braid1.jpeg";
import boxBraid2 from "../Images/Hairstyles/box-braid2.jpeg";
import boxBraid3 from "../Images/Hairstyles/box-braid3.jpeg";
import boxBraid4 from "../Images/Hairstyles/box-braid4.jpeg";
import boxBraid5 from "../Images/Hairstyles/box-braid5.jpeg";
import boxBraid6 from "../Images/Hairstyles/box-braid6.jpeg";
import boxBraid7 from "../Images/Hairstyles/box-braid7.jpeg";
import cornrow1 from "../Images/Hairstyles/cornrow1.jpeg";
import cornrow2 from "../Images/Hairstyles/cornrow2.jpeg";
import cornrow3 from "../Images/Hairstyles/cornrow3.jpeg";
import cornrow4 from "../Images/Hairstyles/cornrow4.jpeg";
import cornrow5 from "../Images/Hairstyles/cornrow5.jpeg";
import cornrow6 from "../Images/Hairstyles/cornrow6.jpeg";
import cornrow7 from "../Images/Hairstyles/cornrow7.jpeg";
import cornrow8 from "../Images/Hairstyles/cornrow8.jpeg";
import cornrow9 from "../Images/Hairstyles/cornrow9.jpeg";
import cornrow10 from "../Images/Hairstyles/cornrow10.jpeg";
import dread1 from "../Images/Hairstyles/dread1.jpeg";
import dread2 from "../Images/Hairstyles/dread2.jpeg";
import dread3 from "../Images/Hairstyles/dread3.jpeg";
import dread4 from "../Images/Hairstyles/dread4.jpeg";
import dread5 from "../Images/Hairstyles/dread5.jpeg";
import dread6 from "../Images/Hairstyles/dread6.jpeg";
import dread7 from "../Images/Hairstyles/dread7.jpeg";
import dread8 from "../Images/Hairstyles/dread8.jpeg";
import dread9 from "../Images/Hairstyles/dread9.jpeg";
import dread10 from "../Images/Hairstyles/dread10.jpeg";
import twist1 from "../Images/Hairstyles/twist1.jpeg";
import twist2 from "../Images/Hairstyles/twist2.jpeg";
import twist3 from "../Images/Hairstyles/twist3.jpeg";
import twist4 from "../Images/Hairstyles/twist4.jpeg";
import twist5 from "../Images/Hairstyles/twist5.jpeg";
import twist6 from "../Images/Hairstyles/twist6.jpeg";
import twist7 from "../Images/Hairstyles/twist7.jpeg";
import twist8 from "../Images/Hairstyles/twist8.jpeg";
import twist9 from "../Images/Hairstyles/twist9.jpeg";
import twist10 from "../Images/Hairstyles/twist10.jpeg";

export const femaleHairstyle = [
  {
    id: 1,
    image: afro1,
    name: "Afro with Buns",
    price: 3230,
    duration: 60,
    attachments: false,
    trending: true,
    category: "Afro",
    popular: false,
  },
  {
    id: 41,
    name: "Big Twist",
    price: 5970,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    category: "Twist",
    image: twist4,
  },
  {
    id: 14,
    name: "Knotless Box Braids",
    price: 5970,
    duration: 240,
    popular: false,
    attachments: true,
    trending: true,
    category: "Box Braids",
    image: boxBraid4,
  },
  {
    id: 4,
    name: "Scattered Afro",
    price: 4970,
    popular: false,
    duration: 40,
    attachments: false,
    trending: false,
    category: "Afro",
    image: afro4,
  },
  {
    id: 5,
    name: "Side Split Afro",
    popular: false,
    price: 4390,
    duration: 30,
    attachments: false,
    trending: true,
    category: "Afro",
    image: afro5,
  },
  {
    id: 40,
    name: "Curly Twist",
    price: 45040,
    popular: false,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Twist",
    image: twist3,
  },
  {
    id: 7,
    name: "Big Buns Afro",
    price: 6687,
    duration: 70,
    popular: false,
    attachments: false,
    trending: false,
    category: "Afro",
    image: afro7,
  },
  {
    id: 27,
    name: "Big Bun Cornrow",
    popular: false,
    price: 6687,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Cornrow",
    image: cornrow10,
  },
  {
    id: 2,
    name: "Long Afro",
    price: 2530,
    duration: 60,
    attachments: false,
    trending: false,
    image: afro2,
    category: "Afro",
    popular: false,
  },
  {
    id: 8,
    name: "Cute Afro",
    price: 5364,
    popular: false,
    duration: 1,
    attachments: false,
    trending: false,
    category: "Afro",
    image: afro8,
  },
  {
    id: 10,
    name: "Side Split Short Afro",
    price: 5486,
    popular: false,
    duration: 40,
    attachments: false,
    trending: false,
    category: "Afro",
    image: afro10,
  },
  {
    id: 11,
    image: boxBraid1,
    name: "Long Braids",
    price: 5987,
    duration: 180,
    attachments: true,
    trending: true,
    popular: false,
    category: "Box Braids",
  },
  {
    id: 12,
    name: "Short Big Braids",
    price: 6530,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    image: boxBraid2,
    category: "Box Braids",
  },
  {
    id: 13,
    name: "Tiny Knotless Braids",
    price: 45040,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Box Braids",
    popular: true,
    image: boxBraid3,
  },
  {
    id: 6,
    name: "Curly Afro",
    price: 5489,
    popular: false,
    duration: 60,
    attachments: false,
    trending: false,
    category: "Afro",
    image: afro6,
  },
  {
    id: 15,
    name: "Shoulder Length Braids",
    price: 4390,
    popular: false,
    duration: 180,
    attachments: true,
    trending: false,
    category: "Box Braids",
    image: boxBraid5,
  },
  {
    id: 31,
    name: "All Side Dread",
    price: 5970,
    duration: 240,
    attachments: true,
    popular: false,
    trending: false,
    category: "Dread",
    image: dread4,
  },
  {
    id: 17,
    name: "Knotless Box Braids",
    price: 5687,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    category: "Box Braids",
    image: boxBraid7,
  },
  {
    id: 19,
    name: "Side Part Cornrow",
    price: 4530,
    duration: 180,
    attachments: true,
    trending: false,
    popular: false,
    image: cornrow2,
    category: "Cornrow",
  },
  {
    id: 20,
    name: "Big Cornrow",
    price: 35040,
    duration: 120,
    attachments: true,
    trending: false,
    popular: false,
    category: "Cornrow",
    image: cornrow3,
  },
  {
    id: 21,
    name: "Cornrow with Zig-Zag",
    price: 4970,
    duration: 180,
    popular: false,
    attachments: true,
    trending: true,
    category: "Cornrow",
    image: cornrow4,
  },
  {
    id: 22,
    name: "Cute Cornrow",
    price: 4390,
    duration: 240,
    attachments: true,
    popular: false,
    trending: false,
    category: "Cornrow",
    image: cornrow5,
  },
  {
    id: 23,
    name: "Interlocked Cornrow",
    price: 5489,
    duration: 240,
    attachments: true,
    popular: false,
    trending: false,
    category: "Cornrow",
    image: cornrow6,
  },
  {
    id: 9,
    name: "Short Round Afro",
    price: 6532,
    duration: 50,
    popular: false,
    attachments: false,
    trending: false,
    category: "Afro",
    image: afro9,
  },
  {
    id: 25,
    name: "Shuku Cornrow",
    price: 5687,
    popular: true,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Cornrow",
    image: cornrow8,
  },
  {
    id: 26,
    name: "Side Shuku Cornrow",
    price: 6687,
    popular: false,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Cornrow",
    image: cornrow9,
  },
  {
    id: 3,
    name: "Scattered Afro",
    price: 45040,
    duration: 30,
    attachments: false,
    trending: false,
    category: "Afro",
    popular: false,
    image: afro3,
  },
  {
    id: 28,
    image: dread1,
    popular: false,
    name: "Short Dreads",
    price: 5230,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Dread",
  },
  {
    id: 29,
    name: "Long Dread with Bun",
    price: 5530,
    duration: 240,
    attachments: true,
    trending: true,
    image: dread2,
    popular: false,
    category: "Dread",
  },
  {
    id: 30,
    name: "Shuku Dread",
    price: 45040,
    popular: false,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Dread",
    image: dread3,
  },
  {
    id: 16,
    name: "Big Cut Braids",
    popular: false,
    price: 5489,
    duration: 180,
    attachments: true,
    trending: false,
    category: "Box Braids",
    image: boxBraid6,
  },
  {
    id: 32,
    name: "Scattered Dread",
    price: 4390,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    category: "Dread",
    image: dread5,
  },
  {
    id: 33,
    name: "Curly Dread",
    price: 5489,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Dread",
    popular: false,
    image: dread6,
  },
  {
    id: 34,
    name: "Side Part Dread",
    price: 6687,
    duration: 300,
    attachments: true,
    popular: true,
    trending: false,
    category: "Dread",
    image: dread7,
  },
  {
    id: 35,
    name: "Long Dread with Bun",
    price: 6687,
    duration: 300,
    attachments: true,
    trending: false,
    category: "Dread",
    image: dread8,
    popular: true,
  },
  {
    id: 36,
    name: "Side Split Short Dread",
    price: 6687,
    popular: false,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Dread",
    image: dread9,
  },
  {
    id: 37,
    name: "Double Bun Dread",
    price: 6687,
    duration: 300,
    attachments: true,
    trending: false,
    popular: false,
    category: "Dread",
    image: dread10,
  },
  {
    id: 38,
    image: twist1,
    name: "Long Twist",
    price: 5230,
    popular: false,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Twist",
  },
  {
    id: 18,
    image: cornrow1,
    name: "Half Braid with Cornrow",
    price: 3230,
    duration: 180,
    popular: false,
    attachments: true,
    trending: true,
    category: "Cornrow",
  },
  {
    id: 39,
    name: "Bob Twist",
    price: 5530,
    duration: 240,
    attachments: true,
    trending: false,
    image: twist2,
    category: "Twist",
    popular: false,
  },
  {
    id: 24,
    name: "Cornrow with Braid",
    price: 6687,
    duration: 70,
    attachments: true,
    popular: false,
    trending: false,
    category: "Cornrow",
    image: cornrow7,
  },
  {
    id: 42,
    name: "Short Twist",
    price: 4390,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Twist",
    popular: false,
    image: twist5,
  },
  {
    id: 43,
    name: "Side Split Twist",
    price: 5489,
    popular: false,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Twist",
    image: twist6,
  },
  {
    id: 44,
    name: "Long Curly Twist",
    price: 6687,
    duration: 300,
    attachments: true,
    trending: false,
    category: "Twist",
    image: twist7,
  },
  {
    id: 45,
    name: "Scanty Twist",
    price: 3687,
    duration: 300,
    attachments: true,
    trending: false,
    popular: false,
    category: "Twist",
    image: twist8,
  },
  {
    id: 46,
    name: "Side Split Long Twist",
    price: 6687,
    duration: 240,
    attachments: true,
    trending: false,
    popular: false,
    category: "Twist",
    image: twist9,
  },
  {
    id: 47,
    name: "Long Tiny Twist",
    price: 4687,
    duration: 300,
    attachments: true,
    trending: true,
    category: "Twist",
    popular: false,
    image: twist10,
  },
];

export const heroimages = [
  afro1,
  boxBraid10,
  afro3,
  boxBraid5,
  dread1,
  malecornrow1,
  malecornrow2,
];
export const aboutimages = [salon1, salon2, salon3, salon4];
